import React from 'react';
import SvgIcon, {
  SvgIconProps,
} from '@mui/material/SvgIcon';

export default function InsuranceIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5763 3.41589C12.8677 3.51789 13.0623 3.79255 13.0623 4.10122V8.61655C13.0623 9.87855 12.6037 11.0832 11.7937 12.0166C11.3863 12.4866 10.871 12.8526 10.3237 13.1486L7.95167 14.4299L5.57567 13.1479C5.02767 12.8519 4.51167 12.4866 4.10367 12.0159C3.29301 11.0826 2.83301 9.87722 2.83301 8.61389V4.10122C2.83301 3.79255 3.02767 3.51789 3.31901 3.41589L7.70701 1.87389C7.86301 1.81922 8.03301 1.81922 8.18834 1.87389L12.5763 3.41589Z"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.21484 7.94513L7.47618 9.20713L10.0748 6.60846"
        stroke="currentColor"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>

  );
}
